import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Message, SectionHeading } from "../components";
import { useSite } from "../../store";
import { normalizeMenu } from "../../utils/menu";
import { MenuGroup } from "./parts";
import "./Menu.scss";

/**
 * The food & drink menu page. Shows the named groups (courses) the couple set
 * in the admin, each with its items, optional descriptions and dietary tags.
 * Groups keep the operator's order. Gated by the `allowMenu` permission (see
 * App routing).
 */
export const Menu = () => {
  const { t } = useTranslation();
  const { config } = useSite();

  const { groups } = useMemo(
    () => normalizeMenu(config.menu),
    [config.menu],
  );
  const visibleGroups = useMemo(
    () => groups.filter((g) => g.items.length > 0),
    [groups],
  );

  return (
    <div className="body">
      <SectionHeading
        title={t("foodMenu.title")}
        subtitle={t("foodMenu.subtitle")}
      />
      {visibleGroups.length === 0 ? (
        <Message variant="primary">{t("foodMenu.empty")}</Message>
      ) : (
        <ol className="menu">
          {visibleGroups.map((group) => (
            <MenuGroup key={group.id} group={group} />
          ))}
        </ol>
      )}
    </div>
  );
};
